import React from 'react';
import { getIconComponentFromName } from './getIconComponentFromName';
export var QuickAccessIcon = function (_a) {
    var iconName = _a.iconName, className = _a.className, primaryFill = _a.primaryFill;
    var Component = getIconComponentFromName(iconName);
    return (React.createElement("span", { className: className }, React.createElement(Component, { primaryFill: primaryFill })));
};
//# sourceMappingURL=QuickAccessIcon.js.map